import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { MenuItem } from "primeng/api";
import * as FlatModels from "@medsurf/flat-models";

@Component({
    selector: 'medsurf-design-content-collapsible-panel',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './collapsible-panel.content.design.html',
    styleUrls: ['./collapsible-panel.content.design.scss'],
    standalone: false
})
export class CollapsiblePanelContentDesign {
  @Input({ required: true }) isMinimized!: boolean;
  @Input({ required: true }) titleText!: string;
  @Input({ required: true }) id!: string;
  @Input() tooltipLabel?: string;
  @Input() menuItems?: MenuItem[];
  @Output() collapsedChange = new EventEmitter<boolean>();
	
	addCollapseMenuItem = () => {
    if (!this.menuItems?.length) {
      return undefined;
    }
		return (this.menuItems).concat([
			{
				separator: true,
			},
			{
				label: this.translate.instant(this.isMinimized ? 'global.panel_open': 'global.panel_close'),
				icon: this.getMinimizedClass(),
				command: () => this.toggleIsMinimized(),
			}
		] satisfies MenuItem[]);
	}
  readonly FlatModels = FlatModels;
	
	constructor(private translate: TranslateService) {}
  
  toggleIsMinimized() {
    this.collapsedChange.emit(!this.isMinimized);
  }
  
  getMinimizedClass() {
    return this.isMinimized ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.PLUS : FlatModels.ButtonDesignModels.ButtonDefaultIcons.MINUS;
  }
  
  getMinimizedLabel() {
    return this.isMinimized ? 'global.panel_open' : 'global.panel_close';
  }
}
